import { Navigate, Outlet, useLocation } from "react-router-dom";
import { PropsysMark } from "@/components/layout/BrandLogo";
import { useMe } from "@/lib/queries";
import { landingPath } from "./landing";

export function FullPageLoader() {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <PropsysMark className="h-12 w-12 animate-pulse" />
    </div>
  );
}

export function RequireAuth() {
  const { data: me, isLoading } = useMe();
  const loc = useLocation();
  if (isLoading) return <FullPageLoader />;
  if (!me) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  return <Outlet />;
}

/** Bejelentkezett felhasználót a belépő oldalakról továbbküld. */
export function GuestOnly() {
  const { data: me, isLoading } = useMe();
  if (isLoading) return <FullPageLoader />;
  if (me) return <Navigate to={landingPath(me.landing)} replace />;
  return <Outlet />;
}

export function LandingRedirect() {
  const { data: me, isLoading } = useMe();
  if (isLoading) return <FullPageLoader />;
  if (!me) return <Navigate to="/login" replace />;
  return <Navigate to={landingPath(me.landing)} replace />;
}

/** A menedzser felület csak munkatársaknak; a tulajdonos / bérlő a portálra kerül. */
export function RequireStaff() {
  const { data: me } = useMe();
  if (me && me.accountType !== "STAFF") return <Navigate to="/portal" replace />;
  return <Outlet />;
}

/** A portál csak tulajdonosoknak és bérlőknek. */
export function RequirePortal() {
  const { data: me } = useMe();
  if (me && me.accountType === "STAFF") return <Navigate to={landingPath(me.landing)} replace />;
  return <Outlet />;
}
